/**
 * EquipmentListComponent builds a section on the left hand side of some admin pages, with a title, search input,
 * list of clickable elements, and some other optional elements such as a button in the top right.
 *
 */


import _ from 'lodash';
import template from './list.component.html';

/* @ngInject */
function ListController($element, $scope, ModalService, appConfig) {
  const vm = this;

  const LIST_LENGTH = 42;
  /** @type {Element} vs-repeat container */
  let listElement;

  vm.userKind = appConfig.user.kind;
  vm.vsOptions = {
    size: LIST_LENGTH
  };

  vm.$onInit = $onInit;
  vm.$postLink = $postLink;
  vm.filterTheList = filterTheList;
  vm.getName = getName;
  vm.authorityToAdd = ['superAdmin', 'partner', 'admin'].includes(vm.userKind);

  vm.applyWarning = ({ deleted, synchronized }) => !deleted && synchronized === false;
  vm.noEquips = () => _.isEmpty(vm.list);
  vm.resetListScroll = () => listElement?.scroll(0, 0);

  vm.openAddModal = openAddModal;

  function $onInit() {
    setList();
  }

  function $postLink() {
    $scope.$watch(() => vm.list, (changes) => {
      if (changes) {
        listElement = listElement || $element.find('ul')[0]; // (May not yet exist due to ng-if=vm.list.length)
        vm.filterTheList();
      }
    }, true);

    $scope.$watch(() => vm.currentId, (newId) => {
      if (!newId) {
        return;
      }

      // Defer (approximately) until the previous (if any) active-element "clears"
      _.delay(() => {
        const activeEleVisible = Boolean($element.find('.list-group-item.active')[0]);
        if (!activeEleVisible) {
        // ? Must do it this [silly] way due to vs-repeat removing li elements
          const targetIdx = vm.listCopy.findIndex(({ id }) => id === newId);
          listElement.scroll({
            top: targetIdx * LIST_LENGTH,
            left: 0,
            behavior: 'smooth'
          });
        }
      }, 1000 / 4);
    });
  }

  function filterTheList() {
    if (vm.search) {
      const search = new RegExp(_.escapeRegExp(vm.search), 'i');
      setList(vm.list, eq => search.test(getName(eq)) || search.test(eq.ip));
    } else {
      setList();
    }
  }

  /**
   * @param {Array<object>} [list=vm.list]
   * @param {string|Function} [filter] Applied to list as arg to `_.filter`
   * @returns {undefined}
   */
  function setList(list = vm.list, filter) {
    list = angular.copy(_.filter(list, filter));
    vm.listCopy = _.sortBy(list, item => getName(item).toLowerCase());
  }

  vm.noEquips = () => _.isEmpty(vm.list);

  function getName(eq) {
    return vm.namePath ? vm.namePath()(eq) : eq.name || eq.rootGroup.name;
  }

  async function openAddModal() {
    const result = await ModalService.open({
      component: vm.addModal,
      size: 'lg'
    });
    vm.addListAction(result);
  }
}

export default {
  name: 'list',
  template,
  transclude: true,
  controller: ListController,
  bindings: {
    titleText: '@',
    list: '<',
    currentId: '<',
    selectAction: '&',
    addModal: '@?',
    placeholder: '@?',
    clickAction: '<?',
    tooltipText: '@?',
    onChangeAction: '<?',
    addListAction: '<?',
    namePath: '&?',
    addAction: '&?',
    rightClickAction: '&?',
    useVsRepeat: '<?'
  }
};
